import React from "react";
import Config from "../config";

async function fetchJson(url) {
  const res = await fetch(url);
  return await res.json();
}

async function fetchRSS(url, options = {}) {
  const { size } = options;
  return await fetchJson(`${Config.PROXY}/rss?url=${encodeURIComponent(url)}&size=${size}`);
}

export default function connectNews(Component) {
  return class ConnectedNews extends React.Component {
    state = {
      news: null
    };

    async componentDidMount() {
      this._isMounted = true;
      this.refresh(this.props.rssFeed);
    }

    componentWillUnmount() {
      this._isMounted = false;
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.rssFeed !== this.props.rssFeed) {
        this.refresh(nextProps.rssFeed);
      }
    }

    async refresh(rssFeed) {
      this._isMounted = true;

      const news = await fetchRSS(rssFeed, { size: 20 });

      if (!this._isMounted) return;

      this.setState({ news });
    }

    render() {
      const { news } = this.state;
      if (!news) return null;

      return <Component {...this.props} news={news} />;
    }
  };
}



// WEBPACK FOOTER //
// ./src/connectors/newsConnector.js